import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCreationUnits } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { creationOccupationsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfCreativeSectionContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const creationOccupations = useAppSelector(creationOccupationsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().creationSections });

  const hasData = creationOccupations.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(creationOccupations, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Кружки" Icon={IconWidgetCreationUnits}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCreativeSectionContainer;
